<!-- src/components/LoanApplicationForm.vue -->

<template>
  <div class="loan-form-container">
    <h3>Ajukan Pinjaman Baru</h3>
    <form @submit.prevent="handleSubmit">
      <div class="form-group">
        <label>Cairkan ke Rekening:</label>
        <select v-model="form.account_id" required>
          <option disabled value="">Pilih Rekening</option>
          <option v-for="acc in props.userAccounts" :key="acc.id" :value="acc.id">
            {{ acc.account_type }} - {{ acc.account_number }}
          </option>
        </select>
      </div>
      <div class="form-group">
        <label>Jumlah Pinjaman:</label>
        <input v-model.number="form.amount" type="number" min="100000" step="50000" required />
      </div>
      <div class="form-group">
        <label>Tujuan Pinjaman:</label>
        <input v-model="form.purpose" type="text" placeholder="Contoh: Modal Usaha" required />
      </div>
      <button type="submit" :disabled="isSubmitting" class="btn btn-primary">
        {{ isSubmitting ? 'Mengajukan...' : 'Ajukan' }}
      </button>
    </form>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'; // <-- IMPOR 'ref'
import api from '@/services/api';
import { useToast } from 'vue-toastification';

const props = defineProps({
  userAccounts: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(['loan-submitted']); // <-- Ganti nama event
const toast = useToast();

const form = reactive({
  account_id: null,
  amount: 100000, // Nilai awal
  purpose: ''
});

const isSubmitting = ref(false);

const handleSubmit = async () => {
  // Tambahkan validasi sederhana di sini
  if (!form.account_id) {
    toast.error("Silakan pilih rekening tujuan pencairan.");
    return;
  }
  isSubmitting.value = true;
  try {
    await api.applyForLoan(form);
    toast.success('Pengajuan pinjaman berhasil dikirim!');
    
    // Reset form
    Object.assign(form, {
      account_id: '',
      amount: 100000,
      purpose: ''
    });
    
    emit('loan-submitted'); // <-- Gunakan nama event yang benar

  } catch (error) {
    const detail = error.response?.data?.detail || "Terjadi kesalahan.";
    toast.error(`Gagal: ${detail}`);
    console.error('Pengajuan pinjaman gagal:', error);
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<style scoped>
  /* Tambahkan style dasar */
  .loan-form-container { 
    margin-top: 2rem; 
    padding: 1.5rem; 
    background-color: #fff; 
    border: 1px solid #e0e0e0;
    border-radius: 8px;
  }
</style>